import styled from 'styled-components';

import { FadeIn } from 'components/Global/animations';

export const PageTemplate = styled.div`
  padding: 2rem 0rem;
  animation: ${FadeIn} ease-in 0.5s;
  animation-iteration-count: 1;
`;
